<template>
  <div class="suggestions">
    <div v-if="$store.state.webNavigator=='pc'">
      <div class="suggestions-bar">
        <div class="suggestions-TltBox">
          <div class="font36px suggestions-Tlt">投诉建议</div>
          <div class="content-advise-p">您如果对我们的产品、服务不满意，或者有好的建议，请您填写以下表格，除周六周日及法定节假日外，您所有的诉求，我们将在24小时内为您解答。
          </div>
        </div>
        <el-form class="suggestions-from" ref="form" :rules="rules" :model="formData">
          <el-form-item label="选择反馈类型：" prop="type">
            <el-select v-model="formData.type" placeholder="请选择反馈类型">
              <el-option value="服务投诉">服务投诉</el-option>
              <el-option value="产品使用">产品使用</el-option>
              <el-option value="订单支付">订单支付</el-option>
              <el-option value="平台体验">平台体验</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="请详细描述您的建议、意见、问题等：" prop="content" id="problem">
            <el-input type="textarea" v-model="formData.content" maxlength="200" placeholder="必填 (200字内)"></el-input>
          </el-form-item>
          <el-form-item>
            <el-upload
              class="upload-demo"
              :action="upload"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              :before-upload="beforeAvatarUpload"
              list-type="picture"
              multiple
              :limit="9"
              :file-list="fileList"
            >
              <!--              v-model="imgUrl"-->
              <span class="col666666 font8px">上传相关购买截图&nbsp;:&nbsp;&nbsp;&nbsp;</span>
              <el-button class="suggestions-button suggestions-input-minBut" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <div class="col666666 suggestions-tip">请填写以下联系方式，方便我们及时回复您的建议、意见、问题！</div>
          <div class="suggestions-inputBox">
            <el-row>
              <el-col class="suggestions-rightBox" :span="12">
                <el-form-item prop="name" class="suggestions-inputBox-p" label="姓名："  id="name">
                  <el-input v-model="formData.name"/>
                </el-form-item>
                <el-form-item prop="phone" class="suggestions-inputBox-p" label="联系手机：" id="phone">
                  <el-input v-model.number="formData.phone" maxlength="11"/>
                </el-form-item>
                <el-form-item class="suggestions-inputBox-p" label="客户编码：">
                  <el-input v-model="formData.crmCode"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="suggestions-inputBox-p2" label="称谓：">
                  <el-select v-model="formData.title">
                    <el-option value="1" label="先生">先生</el-option>
                    <el-option value="2" label="女士">女士</el-option>
                  </el-select>
                </el-form-item>
                <!-- 行为验证 -->
                <div class="popupShowAction" id="CaptchaId"></div>
                <el-form-item prop="code2" class="suggestions-inputBox-p2" label="验证码：" id="phonecode">
                  <el-input class="suggestions-input-code" v-model="formData.code2"/>
                  <el-button
                    type="primary"
                    class="suggestions-button suggestions-input-minBut"
                    @click="getPicCode()"
                  >{{timer?(count+'s'):'获取验证码'}}
                  </el-button>
                </el-form-item>
                <el-form-item prop="buyTime" class="suggestions-inputBox-p2 suggestions-inputBox-time" label="购买时间：">
                  <el-date-picker
                    v-model="formData.buyTime"
                    type="datetime"
                    placeholder="请选择日期"
                    :picker-options="pickerOptions1">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <el-form-item class="suggestions-buttonBox">
            <el-row>
              <el-col class="suggestions-buttonRight" :span="12">
                <el-button class="suggestions-button suggestions-bigBut" @click="onSubmit()">提交</el-button>
              </el-col>
              <el-col class="suggestions-buttonLeft" :span="12">
                <el-button class="suggestions-button suggestions-bigBut" @click="ChangeToList(2)">我的投诉建议</el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
        <div id="code">
          <el-dialog
            class="suggestions-popup"
            :visible.sync="dialogVisible3"
            :modal="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
          >
            <div class="codetitle content-advise-p">提示</div>
            <div class="content-adviseBox">
              <span class="content-advise-p">
                <span class="marginleft2px content-advise-code">验证码&nbsp;:</span>
                <input class="content-advise-input marginleft5px" v-model="code1"/>
              </span>
              <span v-html="this.picCode" style="vertical-align: middle;" @click="picCodeData()"></span>
            </div>
            <div class="submitcode">
              <el-button @click="close('1')">取 消</el-button>
              <el-button type="primary" @click="phoneCodeData()" class="marginleft9px">确 定</el-button>
            </div>
          </el-dialog>
        </div>
        <div id="suc">
          <el-dialog
            :visible.sync="dialogVisible"
            :show-close="false"
            :modal="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
          >
            <span class="dialog_time">({{totalTime}}S)</span>
          </el-dialog>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="banner-advise-p marleft32px">
        您如果对我们的产品和服务不满意，或者有好的建议，请您填写以下表格，我们的客服专员将会与您联系。
      </div>
      <div class="phone-suggestions-from">
        <div class="suggestions-inputBox-Box">
          <label class="phone-suggestions-ActLabel phone-suggestions-label">选择反馈类型：</label>
          <select v-model="formData.type" class="phone-suggestions-select phone-suggestions-input">
            <option class="phone-suggestions-option" v-for="(item , index) in typeList" :key="index" :value="item" :selected="index==0?true:false">
              {{item}}
            </option>
          </select>
        </div>
        <div class="suggestions-inputBox-Box">
          <label class="phone-suggestions-ActLabel phone-suggestions-label">请详细描述您的建议、意见、问题等11：</label>
          <el-input type="textarea" v-model="formData.content" maxlength="200" show-word-limit></el-input>
        </div>
        <div class="suggestions-inputBox-Box">
          <el-upload
            class="phone-suggestions-upload"
            :action="upload"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :before-upload="beforeAvatarUpload"
            list-type="picture"
            multiple
            :limit="9"
            :file-list="fileList"
          >
            <span class="col666666 font24phone">上传相关购买截图&nbsp;:&nbsp;&nbsp;&nbsp;</span>
            <button class="phone-suggestions-button phone-suggestions-minBut" type="primary">点击上传</button>
          </el-upload>
        </div>
        <div class="col666666 phone-suggestions-tip font24phone">请填写以下联系方式，方便我们及时回复您的建议、意见、问题！</div>
        <div class="phone-suggestions-inputBox">
          <div class="suggestions-inputBox-p">
            <label class="phone-suggestions-ActLabel phone-suggestions-label">姓名：</label>
            <input type="text" class="phone-suggestions-input" v-model="formData.name"/>
          </div>
          <div class="suggestions-inputBox-p">
            <label class="phone-suggestions-label">称谓：</label>
            <select v-model="formData.title" class="phone-suggestions-select phone-suggestions-input">
              <option class="phone-suggestions-option" value="1" selected>先生</option>
              <option class="phone-suggestions-option" value="2">女士</option>
            </select>
          </div>
          <div class="suggestions-inputBox-p">
            <label class="phone-suggestions-ActLabel phone-suggestions-label">联系手机：</label>
            <input type="text" class="phone-suggestions-input" v-model.number="formData.phone" maxlength="11"/>
          </div>
          <div class="suggestions-inputBox-p">
            <label class="phone-suggestions-ActLabel phone-suggestions-label">验证码：</label>
            <input class="suggestions-input-code" v-model="formData.code2"/>
            <button
              type="primary"
              class="phone-suggestions-button phone-suggestions-minBut2"
              @click="getPicCode()"
            >{{timer?(count+'s'):'验证码'}}
            </button>
          </div>
          <div class="suggestions-inputBox-p">
            <label class="phone-suggestions-label">客户编码：</label>
            <input type="text" class="phone-suggestions-input" v-model="formData.crmCode"/>
          </div>
          <div class="suggestions-inputBox-p suggestions-inputBox-time">
            <label class="phone-suggestions-label">购买时间：</label>
            <input
              class="phone-suggestions-input"
              type="date"
              v-model="formData.buyTime"/>
          </div>
        </div>
        <div class="suggestions-buttonBox">
          <button class="suggestions-button suggestions-bigBut bigBut-01" @click="onSubmit()">提交</button>
          <button class="suggestions-button suggestions-bigBut bigBut-02" @click="ChangeToList(2)">我的投诉建议</button>
        </div>
      </div>
      <div class="phone-popup-box">
        <el-dialog
          class="suggestions-popup"
          :visible.sync="dialogVisible3"
          :modal="true"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
        >
          <div class="codetitle content-advise-p">提示</div>
          <div class="content-adviseBox">
              <span class="content-advise-p">
                <span class="font30phone">验证码：&nbsp;</span>
                <input class="content-advise-input marginleft5px" v-model="code1"/>
              </span>
            <span v-html="this.picCode" style="vertical-align: middle;" class="popup-pic" @click="picCodeData()"></span>
          </div>
          <div class="submitcode">
            <button class="content-advise-but but-01" @click="close('1')">取 消</button>
            <button class="content-advise-but marginleft9px" type="primary" @click="phoneCodeData()" >确 定</button>
          </div>
        </el-dialog>
        <el-dialog
          class="suggestions-popupBG"
          :visible.sync="dialogVisible"
          :show-close="false"
          :modal="true"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
        >
          <span class="dialog_time">({{totalTime}}S)</span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {$get, $post, } from '@/others/ajax';
import config from '@/others/interface';

export default {
  name: 'suggestions',
  data () {
    return {
      pickerOptions1: {
        disabledDate (time) {
          return time.getTime() > Date.now();
        },
      },
      formData: {
        type: '',
        content: '',
        name: '',
        phone: '',
        crmCode: '',
        title: '',
        code2: '',
        buyTime: '',
      },
      typeList: [
        '服务投诉',
        '产品使用',
        '订单支付',
        '平台体验',
      ],
      imgUrl: [],
      rules: {
        type: [{required: true, message: '请选择反馈类型', trigger: 'blur', }, ],
        content: [{required: true, message: '请详细描述您的建议、意见、问题等', trigger: 'blur', }, ],
        phone: [{required: true, message: '联系手机不能为空', }, ],
        name: [{required: true, message: '姓名不能为空', }, ],
        // buyTime: [{type: 'date', required: false, message: '请选择时间', trigger: 'change', }, ],
        code2: [{required: true, message: '验证码不能为空', }, ],
      },
      reg: new RegExp('^[0-9]*$'),
      upload: 'https://bmstest.gooeto.com/fileAPI/submissionPlatform/user/question',
      picCode: {},
      picId: '',
      code1: '',
      code2: '',
      dialogVisible: false,
      dialogVisible3: false,
      getRandstr: '',
      getTicket: '',
      timer: null,
      count: 0,
      totalTime: 1,
      fileList: [],
    };
  },

  methods: {
    getAction () {
      try {
        new TencentCaptcha(document.getElementById('CaptchaId'), '2056848422', this.callback, {
        //   type: 'embed',
          // sdkOpts:{width:140,height:140},
          needFeedBack: false,
        }).show();
      } catch (e) {
        this.loadErrorCallback();
      }
    },
    // 定义回调函数
    callback (res) {
      // 第一个参数传入回调结果，结果如下：
      // ret         Int       验证结果，0：验证成功。2：用户主动关闭验证码。
      // ticket      String    验证成功的票据，当且仅当 ret = 0 时 ticket 有值。
      // CaptchaAppId       String    验证码应用ID。
      // bizState    Any       自定义透传参数。
      // randstr     String    本次验证的随机串，后续票据校验时需传递该参数。
      console.log('callback:', res);
      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      // res（请求验证码发生错误，验证码自动返回terror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
      // 此处代码仅为验证结果的展示示例，真实业务接入，建议基于ticket和errorCode情况做不同的业务处理
      if (res.ret === 0) {
        this.getTicket = res.ticket;
        this.getRandstr = res.randstr;
        this.dialogVisible3 = true;
      } else if (res.ret === 2) {
        return this.$message.warning('请重试');
      }
    },
    // 定义验证码js加载错误处理函数
    loadErrorCallback () {
      var appid = '';
      // 生成容灾票据或自行做其它处理
      var ticket = 'terror_1001_' + appid + Math.floor(new Date().getTime() / 1000);
      this.callback({
        ret: 0,
        randstr: '@' + Math.random().toString(36).substr(2),
        ticket,
        errorCode: 1001,
        errorMessage: 'jsload_error',
      });
    },
    onSubmit () {
      if (this.$store.state.webNavigator == 'pc') {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.checkPhoneMess();
          } else {
            return false;
          }
        });
      } else {
        if (this.formData.type == '') {
          this.$message.error('请选择反馈类型');
        } else if (this.formData.content == '') {
          this.$message.error('请详细描述您的建议、意见、问题等');
        } else if (this.formData.name == '') {
          this.$message.error('姓名不能为空');
        } else if (this.formData.phone == '') {
          this.$message.error('联系手机不能为空');
        } else if (!this.reg.test(this.formData.phone)) {
          this.$message.error('请输入正确的手机号');
        } else if (this.formData.code2 == '') {
          this.$message.error('验证码不能为空');
        } else {
          this.checkPhoneMess();
        }
      }
    },
    addComplaint (data) {
      this.$post(config.zmlgw + '/complaint/addComplaint', {...data, }).then(res => {
        if (res.code == 200) {
          if (this.$store.state.webNavigator == 'pc') {
            this.$refs.form.resetFields();
          }
          this.fileList = [];
          this.imgUrl = [];
          this.totalTime = 3;
          this.dialogVisible = true;
          let clock = window.setInterval(() => {
            this.totalTime--;
            if (this.totalTime == 0) {
              window.clearInterval(clock);
              this.dialogVisible = false;
            }
          }, 1000);
          this.formData = {
            content: '',
            name: '',
            phone: '',
            type: '',
            buyTime: '',
            crmCode: '',
            imgUrl: '',
            title: '',
          };
        }
      });
    },
    checkPhoneMess () {
      // 检测手机验证码
      $post(config.zmlgw + '/complaint/checkPhoneMess', {
        messageCode: this.formData.code2,
        phone: this.formData.phone,
      }).then((rescheck) => {
        if (rescheck.code == 200) {
          let buyTime = this.formData.buyTime ? this.$myConvertTimeDetails(this.formData.buyTime) : '';
          let data = {
            content: this.formData.content,
            name: this.formData.name,
            phone: this.formData.phone,
            type: this.formData.type,
            buyTime: buyTime,
            crmCode: this.formData.crmCode,
            imgUrl: this.imgUrl.join(','),
            origin: '',
            title: this.formData.title,
            userId: '',
          };
          this.addComplaint(data);
        } else {
          if (rescheck.code == 202) {
            this.$message('请完善相关信息');
          } else {
            this.$message(rescheck.mes);
          }
        }
      });
    },
    countSeconds () {
      if (this.timer) {
        return;
      }
      this.count = 60;
      this.timer = setInterval(() => {
        let a = this.count - 1;
        this.count = a;
        if (a <= 0) {
          clearInterval(this.timer);
          this.timer = null;
          this.count = 60;
        }
      }, 1000);
    },
    handleRemove (file, fileList) {
      this.imgUrl.forEach((item, index) => {

      });
    },
    handleSuccess (response, file, fileList) {
      console.log(33333, fileList);
      if (response.code == 200) {
        this.imgUrl.push(response.data.file);
      }
    },
    beforeAvatarUpload (file) {
      const isIMG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isIMG) {
        this.$message.error('上传图片格式不支持');
      }
      if (!isLt1M) {
        this.$message.error('上传图片大小不能超过 1MB!');
      }
      return isIMG && isLt1M;
    },
    picCodeData () {
      // 获取图形验证码
      $get(config.zmlgw + '/complaint/getSetCaptcha', {
        height: 50,
        width: 150,
      }).then((respic) => {
        if (respic.code == 200) {
          this.picCode = respic.data;
          this.picId = respic.sessionId;
        }
      });
    },
    phoneCodeData () {
      // 获取手机验证码
      $post(config.zmlgw + '/complaint/getPhoneMess', {
        sessionId: this.picId,
        height: 50,
        width: 150,
        captcha: this.code1,
        phone: this.formData.phone,
        randStr: this.getRandstr,
        ticket: this.getTicket,
      }).then((res) => {
        if (res.code == 200) {
          this.close('1');
          this.countSeconds();
          this.$message('手机验证码成功发送');
        } else if (res.code === 202) {
          this.code1 = '';
          this.$message('验证码错误');
          this.picCodeData();
        } else {
          this.code1 = '';
          this.$message(res.mes);
          this.picCodeData();
        }
      });
    },
    getPicCode () {
      if (this.formData.phone != '') {
        if (!this.reg.test(this.formData.phone)) {
          this.$message.error('请输入正确的手机号');
          return;
        }
        if (this.timer) {
          return;
        }
        this.picCodeData();
        this.getAction();
      } else {
        this.$message('请先输入手机号');
      }
    },
    ChangeToList (type) {
      this.$emit('change', type);
    },
    close (type) {
      if (type == '1') {
        this.code1 = '';
        this.dialogVisible3 = !this.dialogVisible3;
      }
    },
  },
};
</script>

<style lang="less" scoped>
  @media screen and (max-width: 800px) {
    @import url("suggestionsPhone.less");
  }

  @media screen and (min-width: 800px) {
    @import url("suggestions.less");
  }
</style>



// WEBPACK FOOTER //
// suggestions.vue